<!--
 * @Author: 汪俊洪
 * @Date: 2021-10-09 13:23:33
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2024-02-27 19:51:25
 * @Description: 发票抬头
-->
<template>
  <el-descriptions :colon="false" title="发票抬头" :column="3">
    <el-descriptions-item label="公司名称：" :span="3">
      {{ detail.companyName || '-' }}
    </el-descriptions-item>
    <el-descriptions-item label="发票抬头：">
      {{ detail.clientName || '-' }}
    </el-descriptions-item>
    <el-descriptions-item label="税务登记证号：">
      {{ detail.clientUnifiedCode || '-' }}
    </el-descriptions-item>
    <el-descriptions-item label="开户银行名称：">
      {{ detail.clientBank || '-' }}
    </el-descriptions-item>
    <el-descriptions-item label="开户账号：">
      {{ detail.clientBankAccount || '-' }}
    </el-descriptions-item>
    <el-descriptions-item label="注册场所地址：">
      {{ detail.clientAddress || '-' }}
    </el-descriptions-item>
    <el-descriptions-item label="注册固定电话：">
      {{ detail.clientPhone || '-' }}
    </el-descriptions-item>
    <el-descriptions-item label="票面备注：" :span="3">
      <span class="remark">{{ detail.thirdInvoiceRemark || '-' }}</span>
    </el-descriptions-item>
    <el-descriptions-item label="客户开票要求：" :span="3">
      <span class="remark">{{ detail.custRemark || '-' }}</span>
    </el-descriptions-item>
  </el-descriptions>
</template>

<script>
export default {
  props: {
    isIframe: {
      type: Boolean,
      default: false
    },
    detail: {
      type: Object,
      default: function () {
        return {}
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@media screen and (max-width: 800px) {
  .ashow {
    display: none;
  }
}
.remark {
  color: #f81b1b;
  word-break: break-all;
  white-space: pre-line;
}
</style>
